/* Klaviyo Popup Override — Apo.Ge
   v3.1 (2026-09-16): Klaviyo form type "popup" (was "full page").
   Design source: Figma "Apo.Ge Website" > Popup page (file 9tsBtrJkbH9TyTAmtJBg5r).
   Restructures the Klaviyo popup DOM for brand styling:
   outer honeycomb card > inner cream card > Klaviyo rows; honey halo circle.
   Popup mode nests the rows one level shallower than full-page mode did, so
   the row parent is derived from the rows themselves (never from a fixed
   child path) — see findRowsParent().
   Checkbox multi-select machinery (yellow dots) preserved from v1 —
   any number of skin concerns can be selected; state is mirrored from the
   real Klaviyo checkboxes onto label.apoge-checked.
   Companion: klaviyo-popup-override.css */

(function () {

  // Every Klaviyo form living inside a dialog. Klaviyo can hold more than one
  // popup open at once (each in its own dialog), so callers loop — never
  // assume the first match is the one the visitor sees.
  function findPopupForms() {
    var out = [];
    var dialogs = document.querySelectorAll('[role="dialog"]');
    for (var d = 0; d < dialogs.length; d++) {
      var forms = dialogs[d].querySelectorAll('.klaviyo-form');
      for (var f = 0; f < forms.length; f++) out.push(forms[f]);
    }
    return out;
  }

  function isRendered(el) {
    var b = el.getBoundingClientRect();
    return b.width > 0 && b.height > 0;
  }

  function hasPendingForm() {
    var forms = findPopupForms();
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].dataset.apogeInitialized !== 'true') return true;
    }
    return false;
  }

  // Initialise every rendered, uninitialised dialog form. Returns true when
  // nothing is left pending (hidden forms are skipped, not counted).
  function initAll() {
    var forms = findPopupForms();
    var pending = false;
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].dataset.apogeInitialized === 'true') continue;
      if (!isRendered(forms[i])) continue;
      if (!initPopup(forms[i])) pending = true;
    }
    return !pending;
  }

  // The element whose direct children are Klaviyo's form rows. Full-page mode
  // put them in form > div > div; popup mode puts them in form > div. Derive
  // from the rows rather than assuming either path.
  function findRowsParent(popup) {
    var row = popup.querySelector('[data-testid="form-row"]');
    if (row) return row.parentElement;
    // Fallback if Klaviyo drops the testid: lowest common ancestor of the
    // email input and the CTA button — rows are siblings, so that's the parent.
    var email = popup.querySelector('.klaviyo-emailinput');
    var btn = popup.querySelector('.klaviyo-form-button');
    if (!email || !btn) return null;
    var node = email.parentElement;
    while (node && node !== popup && !node.contains(btn)) node = node.parentElement;
    return (node && node !== popup) ? node : null;
  }

  // Close badge floats off the outer card's top-right corner (Figma: badge
  // centre is 33px right of the card edge and 27px above the card top).
  // The card height is content-driven, so the badge is placed from the
  // measured card rect instead of a viewport calc.
  function positionClose(closeBtn, container) {
    if (!closeBtn || !container) return;
    if (window.innerWidth < 750) {
      closeBtn.style.left = '';
      closeBtn.style.top = '';
      return;
    }
    var rect = container.getBoundingClientRect();
    if (!rect.width) return;
    closeBtn.style.left = Math.round(rect.right + 33 - 18) + 'px';
    closeBtn.style.top = Math.round(rect.top - 27 - 18) + 'px';
  }

  function initPopup(popup) {
    if (!popup) return false;
    if (popup.dataset.apogeInitialized === 'true') return true;

    var rowsParent = findRowsParent(popup);
    if (!rowsParent) return false;

    var isMobile = window.innerWidth < 750;

    // 1. Build outer (honeycomb) card > inner (cream) card, move every row in.
    //    Both are our own elements — sized and painted entirely in CSS.
    var container = popup.querySelector('.apoge-outer-card');
    if (!container) {
      container = document.createElement('div');
      container.className = 'apoge-outer-card';
      var innerCard = document.createElement('div');
      innerCard.className = 'apoge-inner-card';
      while (rowsParent.firstChild) {
        innerCard.appendChild(rowsParent.firstChild);
      }
      container.appendChild(innerCard);
      rowsParent.appendChild(container);
    }

    var inner = container.querySelector('.apoge-inner-card');
    if (!inner) return false;

    // 2. Honey halo circle behind the card (styled + sized in CSS)
    if (!popup.querySelector('.apoge-halo')) {
      var halo = document.createElement('div');
      halo.className = 'apoge-halo';
      popup.insertBefore(halo, popup.firstChild);
    }

    // Signup step = the step with the email input. The success step has none.
    // Steps 3 and 5's heading copy run on the signup step only: the success
    // step's coupon row is empty until Klaviyo fills in the code, so the
    // spacer rule hid it, and the heading rule overwrote "Welcome to the
    // family" (2026-10-19).
    var isSignupStep = !!popup.querySelector('.klaviyo-emailinput, input[type="email"]');

    // 3. Hide empty spacer rows
    var rows = isSignupStep ? inner.querySelectorAll('[data-testid="form-row"]') : [];
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].parentNode !== inner) continue;
      var text = rows[i].textContent.trim();
      if (text === '' || text === '​') {
        rows[i].style.display = 'none';
      }
    }

    // 4. Outer container sizing lives in CSS (.apoge-outer-card). Popup mode
    //    adds 64px side padding to the form; CSS zeroes it on mobile.

    // 5. Heading — DM Serif Display (Klaviyo applies inline styles, so CSS
    // alone can't win; must set inline here). Subheading (second <p>) gets
    // the Figma spec too: Work Sans 16px olive.
    var allRichtext = popup.querySelectorAll('.klaviyo-form-richtext');
    var headingRt = null;
    for (var r = 0; r < allRichtext.length; r++) {
      if (allRichtext[r].textContent.trim().length > 5) {
        headingRt = allRichtext[r];
        break;
      }
    }
    if (headingRt) {
      // Block elements of the rich text — the builder may emit <p> or <h1>–<h6>
      // depending on how the copy was entered; first block is the heading,
      // second (if any) the subheading.
      var ps = headingRt.querySelectorAll('h1, h2, h3, h4, h5, h6, p');
      var headingSize = isMobile ? '32px' : '40px';
      if (ps[0]) {
        // Heading copy is fixed to the Figma spec (sentence case). The live
        // form's builder copy drifted ("tell us your skin concerns"), so the
        // text is enforced here until the builder is corrected.
        var SPEC_HEADING = 'Enjoy 10% off your first order';
        if (isSignupStep && ps[0].textContent.replace(/\s+/g, ' ').trim() !== SPEC_HEADING) {
          var leaf = ps[0];
          while (leaf.children.length === 1 && leaf.firstElementChild.textContent.trim() === leaf.textContent.trim()) {
            leaf = leaf.firstElementChild;
          }
          leaf.textContent = SPEC_HEADING;
        }
        ps[0].style.fontFamily = '"DM Serif Display", serif';
        ps[0].style.fontSize = headingSize;
        ps[0].style.fontWeight = '400';
        ps[0].style.letterSpacing = '0.6px';
        ps[0].style.lineHeight = '1.3';
        ps[0].style.textAlign = 'center';
        ps[0].style.textTransform = 'none';
        ps[0].style.margin = '0';
        ps[0].style.color = 'rgb(79, 81, 39)';
        var headingSpans = ps[0].querySelectorAll('span, strong, em, b');
        for (var hs = 0; hs < headingSpans.length; hs++) {
          headingSpans[hs].style.fontFamily = '"DM Serif Display", serif';
          headingSpans[hs].style.fontSize = headingSize;
          headingSpans[hs].style.fontWeight = '400';
          headingSpans[hs].style.fontStyle = 'normal';
          headingSpans[hs].style.textTransform = 'none';
          headingSpans[hs].style.color = 'rgb(79, 81, 39)';
        }
      }
      if (ps[1]) {
        ps[1].style.textAlign = 'center';
        ps[1].style.marginTop = '12px';
        ps[1].style.fontFamily = '"Work Sans", Arial, sans-serif';
        ps[1].style.fontSize = '16px';
        ps[1].style.lineHeight = '1.4';
        ps[1].style.color = 'rgb(79, 81, 39)';
        var subSpans = ps[1].querySelectorAll('span');
        for (var ss = 0; ss < subSpans.length; ss++) {
          subSpans[ss].style.fontFamily = '"Work Sans", Arial, sans-serif';
          subSpans[ss].style.fontSize = '16px';
          subSpans[ss].style.color = 'rgb(79, 81, 39)';
        }
      }
    }

    // 6. Buttons — compact the CTA to 44px
    var buttons = popup.querySelectorAll('.klaviyo-form-button');
    for (var b = 0; b < buttons.length; b++) {
      var btnText = buttons[b].textContent;
      if (btnText.indexOf('GET 10%') !== -1) {
        buttons[b].style.cssText += '; height:44px !important; min-height:0 !important; padding:0 24px !important; font-size:13px !important; max-height:44px !important;';
      }
    }

    // 7. Squash button row wrappers
    var children = inner.children;
    for (var c = 0; c < children.length; c++) {
      if (children[c].style.display === 'none') continue;
      var t = children[c].textContent;
      var isCtaRow = t.indexOf('GET 10% OFF') !== -1;
      if (isCtaRow) {
        children[c].style.cssText += '; height:auto !important; min-height:0 !important; padding:0 !important;';
        var comp = children[c].querySelector('[data-testid="form-component"]');
        if (comp) comp.style.cssText += '; height:auto !important; min-height:0 !important; padding:0 !important;';
      }
    }

    // 8. Even spacing between visible rows
    var visible = [];
    for (var v = 0; v < children.length; v++) {
      if (children[v].style.display !== 'none' && children[v].offsetHeight > 0) {
        visible.push(children[v]);
      }
    }
    for (var s = 0; s < visible.length; s++) {
      visible[s].style.marginTop = '0';
      visible[s].style.marginBottom = (s < visible.length - 1) ? '16px' : '0';
    }

    // 9. Checkbox row spacing
    var fieldset = popup.querySelector('.klaviyo-checkboxes fieldset');
    if (fieldset) {
      var fieldChildren = fieldset.children;
      for (var f = 0; f < fieldChildren.length; f++) {
        fieldChildren[f].style.marginBottom = '8px';
        fieldChildren[f].style.paddingTop = '4px';
        fieldChildren[f].style.paddingBottom = '4px';
      }
    }
    var labels = popup.querySelectorAll('.klaviyo-checkboxes label');
    for (var l = 0; l < labels.length; l++) {
      labels[l].style.paddingTop = '6px';
      labels[l].style.paddingBottom = '6px';
      labels[l].style.display = 'flex';
      labels[l].style.alignItems = 'center';
    }

    // 10. Close button — badge/colors live in CSS; desktop left/top are
    // measured from the outer card (positionClose), plus glyph geometry and
    // neutralizing Klaviyo's drawn circle
    var closeBtn = popup.closest('[role="dialog"]');
    closeBtn = closeBtn ? closeBtn.querySelector('.klaviyo-close-form') : document.querySelector('.klaviyo-close-form');
    if (closeBtn) {
      positionClose(closeBtn, container);
      // Re-measure once web fonts settle (card height shifts) and on resize
      setTimeout(function () { positionClose(closeBtn, container); }, 600);
      if (!closeBtn.dataset.apogeResize) {
        closeBtn.dataset.apogeResize = 'true';
        window.addEventListener('resize', function () { positionClose(closeBtn, container); });
      }
      var svg = closeBtn.querySelector('svg');
      if (svg) {
        var glyph = isMobile ? '22' : '16';
        svg.setAttribute('width', glyph);
        svg.setAttribute('height', glyph);
      }
      var path = closeBtn.querySelector('path');
      if (path) {
        path.setAttribute('stroke', '#FFF8EF');
        path.setAttribute('stroke-width', '1.5');
        path.setAttribute('fill', 'none');
        path.style.stroke = '#FFF8EF';
      }
      var circle = closeBtn.querySelector('circle');
      if (circle) {
        circle.setAttribute('stroke', 'rgba(0,0,0,0)');
        circle.setAttribute('fill', 'rgba(0,0,0,0)');
      }
    }

    // 11. Hide all SVG checkboxes
    hideSVGs();

    // 12. Checkbox click handler — multi-select state mirror (PRESERVE:
    // this is what lets more than one concern be selected with yellow dots)
    var checkboxArea = popup.querySelector('.klaviyo-checkboxes');
    if (checkboxArea && !checkboxArea.dataset.apogeHandled) {
      checkboxArea.dataset.apogeHandled = 'true';
      checkboxArea.addEventListener('click', function () {
        setTimeout(function () {
          updateDots();
          hideSVGs();
        }, 50);
        setTimeout(function () {
          updateDots();
          hideSVGs();
        }, 150);
      });
    }

    // 13. Remove text highlight backgrounds
    var bgSpans = popup.querySelectorAll('.klaviyo-form-richtext span[data-color]');
    for (var bg = 0; bg < bgSpans.length; bg++) {
      bgSpans[bg].style.backgroundColor = 'transparent';
    }

    // 14. Flag popup-open on <html> — CSS uses it to hide the Smile.io
    // rewards launcher while the popup is up (removed on Klaviyo close event)
    document.documentElement.classList.add('apoge-popup-open');

    // 15. Make overlay transparent now that inner card is built
    // (NEVER do this in CSS — pre-init transparency makes the popup render
    // invisible while Klaviyo counts it as viewed and suppresses re-display)
    var dialog = popup.closest('[role="dialog"]');
    if (dialog) {
      dialog.style.backgroundColor = 'transparent';
      // Popup mode's scale() wrapper (dialog's only child) shrinks the form
      // to fit Klaviyo's configured width and breaks position:fixed inside
      // it. CSS neutralises it via :has(); mirror inline for older engines.
      var scaleWrap = dialog.firstElementChild;
      if (scaleWrap && /scale\(/.test(scaleWrap.style.transform || '')) {
        scaleWrap.style.transform = 'none';
        scaleWrap.style.marginLeft = '0';
        scaleWrap.style.marginRight = '0';
        scaleWrap.style.maxHeight = 'none';
      }
    }

    // 16. Mark done. The observer stays connected: a second popup form can
    // open later in its own dialog and needs the same restructure.
    popup.dataset.apogeInitialized = 'true';
    return true;
  }

  // Restore the rewards launcher when the last popup closes, and re-run the
  // restructure when a form (re)opens — Klaviyo builds a fresh DOM on every
  // open.
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail) return;
    if (e.detail.type === 'close') {
      setTimeout(function () {
        var forms = findPopupForms();
        var stillOpen = false;
        for (var i = 0; i < forms.length; i++) {
          if (isRendered(forms[i])) { stillOpen = true; break; }
        }
        if (!stillOpen) document.documentElement.classList.remove('apoge-popup-open');
      }, 100);
    } else if (e.detail.type === 'open') {
      document.documentElement.classList.add('apoge-popup-open');
      tryInit(0);
    }
  });

  function hideSVGs() {
    var svgs = document.querySelectorAll('.klaviyo-checkboxes label svg');
    for (var i = 0; i < svgs.length; i++) {
      svgs[i].style.cssText = 'display:none !important; width:0; height:0; position:absolute;';
    }
  }

  function updateDots() {
    var labels = document.querySelectorAll('.klaviyo-checkboxes label');
    for (var i = 0; i < labels.length; i++) {
      var isChecked = false;
      var inputId = labels[i].getAttribute('for');
      if (inputId) {
        var input = document.getElementById(inputId);
        if (input && input.checked) isChecked = true;
      }
      if (isChecked) {
        labels[i].classList.add('apoge-checked');
      } else {
        labels[i].classList.remove('apoge-checked');
      }
    }
  }

  // Watch for popup forms to appear (stays connected for the page lifetime —
  // Klaviyo can open a second form later)
  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      if (mutations[m].addedNodes.length) {
        if (hasPendingForm()) tryInit(0);
        break;
      }
    }
  });

  var initTimer = null;
  function tryInit(attempt) {
    if (attempt > 5) return;
    if (initTimer) { clearTimeout(initTimer); initTimer = null; }
    var done = initAll();
    if (!done) {
      initTimer = setTimeout(function () { initTimer = null; tryInit(attempt + 1); }, 300);
    }
  }

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (hasPendingForm()) {
    tryInit(0);
  }
})();
